/**
 * Divayur Custom Sticky Header Enhancements
 * Adds additional functionality to the header component
 */

document.addEventListener('DOMContentLoaded', () => {
  // Get header component
  const headerComponent = document.querySelector('header-component');
  if (!headerComponent) return;
  
  // Variable to track scroll position
  let lastScrollTop = 0;
  
  // Add scroll event listener
  window.addEventListener('scroll', () => {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    // Add extra shadow and background opacity when scrolling down
    if (currentScrollTop > 50) {
      headerComponent.classList.add('header--scrolled');
      
      // When scrolling down, add a class to compress the header
      if (currentScrollTop > lastScrollTop) {
        headerComponent.classList.add('header--compact-nav');
      } else {
        // When scrolling up, remove the class
        headerComponent.classList.remove('header--compact-nav');
      }
    } else {
      headerComponent.classList.remove('header--scrolled');
      headerComponent.classList.remove('header--compact-nav');
    }
    
    lastScrollTop = currentScrollTop;
  });
  
  // Add additional styles for scrolled state
  const styleElement = document.createElement('style');
  styleElement.textContent = `
    header-component.header--scrolled {
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2) !important;
      background-color: rgba(0, 0, 0, 0.95) !important;
    }
    
    header-component.header--compact-nav .header__row {
      padding-top: 0.5rem !important;
      padding-bottom: 0.5rem !important;
    }
    
    header-component.header--scrolled .header__row--top {
      border-bottom-color: rgba(255, 215, 0, 0.5) !important;
    }
  `;
  document.head.appendChild(styleElement);
});
